<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>

    <side-bar
    >
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/dashboard">
        <md-icon>dashboard</md-icon>
        <p>Inicio</p>
      </sidebar-link>
      <sidebar-link v-if="!isPresident" to="/files">
        <md-icon>person</md-icon>
        <p>Mis archivos</p>
      </sidebar-link>
      <sidebar-link to="/evidence">
        <md-icon>content_paste</md-icon>
        <p>Evidencias</p>
      </sidebar-link>
      <sidebar-link v-if="isPresident" to="/sentencing">
        <md-icon>gavel</md-icon>
        <p>Sentencias</p>
      </sidebar-link>
      <sidebar-link to="/notifications">
        <md-icon>notifications</md-icon>
        <p>Notificaciones</p>
      </sidebar-link>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>


      <dashboard-content> </dashboard-content>

      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "@/pages/Layout/MobileMenu.vue";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
    MobileMenu,
  },
  computed: {
    isPresident() {
      return (
        this.$delegateStore.state.authContext &&
        this.$delegateStore.state.authContext.role === "president"
      );
    },
  },
  data() {
    return {
      sidebarBackground: "blue",
      sidebarBackgroundImage: require("@/assets/img/sidebar-2.jpg"),
    };
  },
};
</script>
